export { CompareSpecs } from "./CompareSpecs";